var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._v(" 合同 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }